import { render, staticRenderFns } from "./upOrder.vue?vue&type=template&id=20d23aa5&scoped=true"
import script from "./upOrder.vue?vue&type=script&lang=js"
export * from "./upOrder.vue?vue&type=script&lang=js"
import style0 from "./upOrder.vue?vue&type=style&index=0&id=20d23aa5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d23aa5",
  null
  
)

export default component.exports